import { Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone';
import { swalError } from '../notification/swal';
import ButtonCustom from '../button/buttonCustom';
import { RouteImage } from '../../assets/routeImage';
import { ButtonContained, ButtonOutlined } from '../mui-custom/MuiCustom';
import { ResourcePathApi } from '../../constants/resource.pathapi';
// import { icons } from '../../../constants/images';
// import CMSApi from '../../../api/cms/cms.api';

export default function Logo(props: any) {
    const { file, setFile, setEdit, edit } = props
    const [url, setUrl] = useState<any>('')
    const [pathUrl, setPathUrl] = useState<any>(null);

    const { getRootProps, getInputProps, open, acceptedFiles } = useDropzone({
        // Disable click and keydown behavior
        maxFiles: 1,
        noClick: true,
        noKeyboard: true,
        maxSize: 10000000,
        accept: {
            'image/png': ['.png'],
            'image/jpeg': ['.jpeg'],
            'image/svg+xml': ['.svg'],
        },
        onDropRejected: (fileRejections) => {
            swalError(fileRejections[0].errors.map((x) => x.code === 'file-invalid-type' ? 'ไม่สามารถเพิ่มไฟล์ประเภทนี้ได้' : x.code === 'file-too-large' ? 'ไฟล์มีขนาดใหญ่เกินไป' : 'ไม่สามารถเพิ่มไฟล์นี้ได้').join('/'))
        },
    });

    useEffect(() => {
        if (acceptedFiles[0]) {
            setFile(acceptedFiles[0])
            setUrl(URL.createObjectURL(acceptedFiles[0]))
        }
    }, [acceptedFiles])

    useEffect(() => {
        const fetchPath = async () => {
            const path = await ResourcePathApi();
            setPathUrl(path);
        }
        fetchPath();
    }, [])


    return (
        <div>
            <Typography>สัญลักษณ์</Typography>
            {edit ? !file ?
                <div style={{
                    borderRadius: '10px',
                    border: '1px dashed #C1C3C7',
                    padding: '12px',
                    marginBottom: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '189px'
                }} {...getRootProps({ className: 'dropzone' })}>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }}>
                        {/* <icons.uploadCloud /> */}
                        <Typography sx={{ fontSize: '14px', fontWeight: '500', marginTop: '12px' }}>ลากหรือเลือกไฟล์เพื่ออัปโหลด</Typography>
                        <Typography sx={{ fontSize: '14px', fontWeight: '300', color: 'rgba(0, 0, 0, 0.40)', marginBottom: '12px' }}>Word, Excel, PDF, JPG or GIF ขนาดไม่เกิน 10MB</Typography>
                        <ButtonCustom variant={'outlined'}
                            endIcon={<img src={RouteImage.download} />}
                            textButton={'เลือกไฟล์'}
                            onClick={open}
                            btnStyle={{
                                '&.MuiButton-outlined': {
                                    color: `#0A77FF !important`,
                                    border: `1px dashed #0A77FF !important`,
                                    backgroundColor: '#fff !important',
                                    borderRadius: "10px !important",
                                    '&:hover': {
                                        color: `#0A77FF  !important`,
                                        border: `1px dashed #0A77FF !important`,
                                        backgroundColor: '#fff !important'
                                    },
                                },
                            }}
                        />
                    </div>
                    <input {...getInputProps()} />

                </div> : <div style={{
                    borderRadius: '10px',
                    border: '1px dashed #C1C3C7',
                    padding: '12px',
                    marginBottom: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    height: '189px'
                }} >
                    <div>
                        <img src={url} style={{ height: "140px" }} />
                        <div style={{
                            marginTop: '4px',
                            width: '140px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <Typography style={{
                                whiteSpace: 'nowrap',
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: "1",
                                overflow: "hidden",
                            }}>{file?.name}</Typography>
                            {edit &&
                                <div style={{
                                    marginLeft: '5px'
                                }} onClick={() => setFile(null)} />}
                        </div>
                    </div>
                </div>
                : <div style={{
                    borderRadius: '10px',
                    border: '1px dashed #C1C3C7',
                    padding: '12px',
                    marginBottom: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    height: '189px'
                }} >
                    <div>
                        <img src={pathUrl && `${pathUrl.REACT_APP_BASE_API}/app-logo`} style={{ height: "140px" }} />
                        <div style={{
                            marginTop: '4px',
                            width: '140px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                        </div>
                    </div>
                </div>}
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                {edit ? <ButtonCustom variant={'outlined'}
                    textButton={'ยกเลิก'}
                    onClick={() => { setEdit(false) }}
                    style={{ marginRight: '4px' }}
                    btnStyle={{
                        '&.MuiButton-outlined': {
                            color: `#ff2a2a !important`,
                            border: `2px solid #ff2a2a !important`,
                            borderRadius: "10px !important",
                            '&:hover': {
                                color: `#ff2a2a  !important`,
                                border: `2px solid #ff2a2a !important`,
                                backgroundColor: '#FFFAF2 !important'
                            },
                        },
                    }} /> :
                    <ButtonOutlined
                        sx={{ maxWidth: 150 }}
                        startIcon={<img width={20} src={RouteImage.cloudIconUpload} />}
                        onClick={() => {
                            setEdit(true)
                            setFile(null)
                        }}
                    >
                        <Typography className='text-primary'> {"อัพโหลดไฟล์"}</Typography>
                    </ButtonOutlined>
                }
            </div>
        </div>
    )
}
